import myzxios from '../utils/myaxios'

export function findUser(data){
    return myzxios({
        url: '/manager/pool/findUser',
        data,
        method: 'POST'
    })
}

export function addUser(data){
    return myzxios({
        url: '/manager/pool/addUser',
        data,
        method: 'POST'
    })
}

export function delUser(data){
    return myzxios({
        url: '/manager/pool/deleteUser/'+data,
        method: 'delete'
    })
}

export function resetPassword(data){
    return myzxios({
        url: '/manager/pool/resetPassword',
        data,
        method: 'post'
    })
}

export function findPool(data){
    return myzxios({
        url: '/manager/pool-list/find',
        data,
        method: 'post'
    })
}

export function addPool(data){
    return myzxios({
        url: '/manager/pool-list/add',
        data,
        method: 'post'
    })
}

export function savePrice(data){
    return myzxios({
        url: '/manager/pool-list/savePrice',
        data,
        method: 'post'
    })
}

export function packetList(){
    return myzxios({
        url: '/manager/pool-list/packetList'
    })
}

export function saveFlow(data){
    return myzxios({
        url: '/manager/pool-list/saveFlow',
        data,
        method: 'post'
    })
}

export function orderList(data){
    return myzxios({
        url: '/manager/pool-order/getOrderList',
        data,
        method: 'post'
    })
}

export function getPoolList(){
    return myzxios({
        url: '/manager/pool-list/getPoolList',
    })
}

export function findPoolFlow(data){
    return myzxios({
        url: '/manager/pool-flow/findPoolFlow',
        data,
        method: 'post'
    })
}

export function ExportingCardDetails(data){
    return myzxios({
        url: '/manager/pool-flow/ExportingCardDetails',
        data,
        method: 'post'
    })
}

export function selectPacketList(data){
    return myzxios({
        url: '/manager/pool-packet/selectPacketList',
        data,
        method: 'post'
    })
}

export function addPacket(data){
    return myzxios({
        url: '/manager/pool-packet/addPacket',
        data,
        method: 'post'
    })
}
